require('datatables-bootstrap');

var $modalTaxes = $('#modal-export-nf');
var $formSearchTableDataReportTax = $('form#report-nf-taxes');
var searchTableDataReportTax = (function ($) {

    var $dataTableNote;
    var $dataTableTax;
    var params = {};

    return {
        init: function () {

            this.createTableNote();
            this.createTableTax();

            var _this = this;

            $('body').on('click', 'button#reporNFTaxes', function () {
                var $btn = $(this);
                var type = $btn.data('type');
                _this.sendReportNFTaxes(type);
            });
        },
        getTableNote: function () {
            return $('table.datatable-note');
        },
        createTableNote: function () {

            var $table = this.getTableNote();
            var $dataArray = this.getFieldTable($table);
            var $fields = $dataArray[0];
            var $orders = $dataArray[1];

            var _this = this;

            $dataTableNote = this.getTableNote().DataTable({
                processing: true,
                serverSide: true,
                searching: false,
                scrollY: "228px",
                scrollCollapse: true,
                ajax: {
                    url: this.getTableNote().data('url'),
                    data: this.getParams
                },
                columns: $fields,
                order: $orders,
                language: {
                    "sProcessing": "A processar...",
                    "sLengthMenu": "Mostrar _MENU_ registos",
                    "sZeroRecords": "Não foram encontrados resultados",
                    "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registos",
                    "sInfoEmpty": "Mostrando de 0 até 0 de 0 registos",
                    "sInfoFiltered": "(filtrado de _MAX_ registos no total)",
                    "sInfoPostFix": "",
                    "sSearch": "Procurar:",
                    "sUrl": "",
                    "oPaginate": {
                        "sFirst": "Primeiro",
                        "sPrevious": "Anterior",
                        "sNext": "Seguinte",
                        "sLast": "Último"
                    }
                },
                "createdRow": function (row, data, index) {
                    $(row).unbind('click');
                    $(row).on('click', function () {
                        _this.getTableNote().find('tr.selected').removeClass('selected');

                        $(row).addClass('selected');

                        _this.clearItems();
                        _this.createTableTax();

                        if (data.items.length > 0) {
                            for (item of data.items) {
                                var prod = item.prod;
                                _this.addItem([
                                    item['@attributes']['nItem'] || '',
                                    prod.cProd || '',
                                    prod.cEAN || '',
                                    prod.xProd || '',
                                    prod.CFOP || '',
                                    prod.uCom || '',
                                    prod.qCom || '',
                                    prod.vUnCom || '',
                                    prod.vProd || '',
                                ]);
                            }
                        } else {
                            var prod = data.items.prod;
                            _this.addItem([
                                data.items['@attributes']['nItem'] || '',
                                prod.cProd || '',
                                prod.cEAN || '',
                                prod.xProd || '',
                                prod.CFOP || '',
                                prod.uCom || '',
                                prod.qCom || '',
                                prod.vUnCom || '',
                                prod.vProd || '',
                            ]);
                        }
                    });
                }
            });

            $formSearchTableDataReportTax.find('button[type="submit"]').on('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                $dataTableNote.ajax.reload();
            });
        },
        getTableTax: function () {
            return $('table.datatable-tax');
        },
        createTableTax: function () {
            $dataTableTax = this.getTableTax().DataTable({
                paging: false,
                scrollY: "228px",
                scrollCollapse: true,
                language: {
                    "sProcessing": "A processar...",
                    "sLengthMenu": "Mostrar _MENU_ registos",
                    "sZeroRecords": "Não foram encontrados resultados",
                    "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registos",
                    "sInfoEmpty": "Mostrando de 0 até 0 de 0 registos",
                    "sInfoFiltered": "(filtrado de _MAX_ registos no total)",
                    "sInfoPostFix": "",
                    "sSearch": "Procurar:",
                    "sUrl": "",
                    "oPaginate": {
                        "sFirst": "Primeiro",
                        "sPrevious": "Anterior",
                        "sNext": "Seguinte",
                        "sLast": "Último"
                    }
                },
            });
        },
        getParams: function (data) {

            var formdata = $formSearchTableDataReportTax.serializeArray();

            params['draw'] = data.draw;
            params['start'] = data.start;
            params['length'] = data.length;
            params['order'] = [];

            for (var order of data.order) {
                params['order'].push({
                    column: data.columns[order.column].data,
                    dir: order.dir
                });
            }

            $(formdata).each(function (idx, row) {
                params[row.name] = row.value;
            });

            return params;
        },
        getFieldTable: function ($table) {
            var $fields;
            var $orders = [];

            $fields = $table.find('thead tr th').map(function (index, element) {
                if ($(element).data('order'))
                    $orders.push([index, $(element).data('order')]);

                return {
                    'data': $(element).data('field'),
                    "orderable": $(element).data('orderable') || false
                };
            });

            return [$fields, $orders];
        },
        sendReportNFTaxes: function (type) {

            $formSearchTableDataReportTax.find('input[name="export"]').val(type);

            var $formModal = $modalTaxes.find('form#taxes');
            var $inputs = $formModal.find('input[type="checkbox"]');

            $inputs.each(function () {
                var $inp = $(this);
                $formSearchTableDataReportTax.find('input[name="' + $inp.attr('name') + '"]').attr('checked', $inp.is(':checked'));
            });

            var order = params['order'][0];
            $formSearchTableDataReportTax.find('input[name="order[0][column]"]').val(order['column']);
            $formSearchTableDataReportTax.find('input[name="order[0][dir]"]').val(order['dir']);

            $modalTaxes.modal('hide');
            $formSearchTableDataReportTax.submit();
        },
        addItem: function (item) {
            $dataTableTax.row.add(item).draw(false);
        },
        clearItems: function () {
            $dataTableTax.destroy();
            this.getTableTax().find('tbody').empty();
        }
    };
})($);

if ($formSearchTableDataReportTax.length) {
    searchTableDataReportTax.init();
}


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-datatable-report-taxes.js